import types from './types';
import { ThunkDispatch } from "redux-thunk";
import api from 'constants/api';
import _get from "lodash/get";
import { createStatistic } from 'store/app/actions';

export interface ClaimHistory {
  RmiCompanyId: string,
  RmiEndDate: string | null,
  RmiMemberKeyId: string,
  RmiStartDate: string,
  UserId: string,
  UserRole: number
}

export const getSubmitted = (userId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_SUBMITTED_CLAIM_REQUEST });

  return api.claim.getSubmitted(userId)
    .then((res: any) => {

      dispatch({
        type: types.GET_SUBMITTED_CLAIM_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_SUBMITTED_CLAIM_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getSubmittedUsingEdifecs = (searchObject: Object) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_SUBMITTED_CLAIM_REQUEST });

  return api.claim.getSubmittedUsingEdifecs(searchObject)
    .then((res: any) => {

      dispatch({
        type: types.GET_SUBMITTED_CLAIM_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_SUBMITTED_CLAIM_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getSubmissionFile = (submissionId: string, fileType: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_CLAIM_SUBMISSION_FILE_REQUEST });

  return api.claim.getSubmissionFile(submissionId, fileType)
    .then((res: any) => {

      dispatch({
        type: types.GET_CLAIM_SUBMISSION_FILE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_CLAIM_SUBMISSION_FILE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getSubmissionFileUsingEdifecs = (submissionId: string, fileType: string, refNum: string, ipa: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_CLAIM_SUBMISSION_FILE_REQUEST });

  return api.claim.getSubmissionFileUsingEdifecs(submissionId, fileType, refNum, ipa)
    .then((res: any) => {

      dispatch({
        type: types.GET_CLAIM_SUBMISSION_FILE_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_CLAIM_SUBMISSION_FILE_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const search = (searchObject: Object) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.claim.isPosting) { return Promise.reject(); }

  dispatch({ type: types.SEARCH_CLAIMS_REQUEST });

  return api.claim.search(searchObject)
    .then((res: any) => {

      dispatch({
        type: types.SEARCH_CLAIMS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.SEARCH_CLAIMS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const create = (companyId: string, membKeyId: string, provKeyId: string, userId: string, hpCode: string, startDate: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.claim.isCreating) { return Promise.reject(); }

  dispatch({ type: types.CREATE_CLAIM_REQUEST });

  return api.claim.create(companyId, membKeyId, provKeyId, userId, hpCode, startDate)
    .then((res: any) => {

      dispatch({
        type: types.CREATE_CLAIM_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.CREATE_CLAIM_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const save = (claim: any) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.claim.isSaving) { return Promise.reject(); }

  dispatch({ type: types.SAVE_CLAIM_REQUEST });

  return api.claim.save(claim)
    .then((res: any) => {

      dispatch({
        type: types.SAVE_CLAIM_SUCCESS,
        payload: res,
      });

      dispatch(createStatistic(
        'MIGRATION', 
        sessionStorage.getItem('ipaGroup')!, 
        0, 
        'CLAIMS SUCCESS', 
        sessionStorage.getItem('user_id')! 
      ));

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.SAVE_CLAIM_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getEZ = (claimNo: string, companyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_EZ_CLAIM_REQUEST });

  return api.claim.getEZ(claimNo, companyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_EZ_CLAIM_SUCCESS,
        payload: res,
      });

      dispatch(createStatistic(
        'MIGRATION', 
        sessionStorage.getItem('ipaGroup')!, 
        1, 
        'CLAIMS FAILURE', 
        sessionStorage.getItem('user_id')! 
      ));

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_EZ_CLAIM_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const cancel = (cancelClaimData: Object) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.claim.isCanceling) { return Promise.reject(); }

  dispatch({ type: types.CANCEL_CLAIM_REQUEST });

  return api.claim.cancel(cancelClaimData)
    .then((res: any) => {

      dispatch({
        type: types.CANCEL_CLAIM_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.CANCEL_CLAIM_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const postHistory = (member: ClaimHistory) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {
  if (getState().rootReducer.claim.isPostingHistory) { return Promise.reject(); }

  dispatch({ type: types.POST_CLAIM_HISTORY_REQUEST });

  return api.claim.postHistory(member)
    .then((res: any) => {

      dispatch({
        type: types.POST_CLAIM_HISTORY_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.POST_CLAIM_HISTORY_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const uploadAttachment = (uploadObject: Object) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.UPLOAD_CLAIM_ATTACHMENT_REQUEST });

  return api.claim.uploadAttachment(uploadObject)
    .then((res: any) => {

      dispatch({
        type: types.UPLOAD_CLAIM_ATTACHMENT_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.UPLOAD_CLAIM_ATTACHMENT_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getEzcapClaimStatus = (companyId: string, claimNo: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_EZ_CLAIM_STATUS_REQUEST });

  return api.claim.getEzcapClaimStatus(companyId, claimNo)
    .then((res: any) => {

      dispatch({
        type: types.GET_EZ_CLAIM_STATUS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_EZ_CLAIM_STATUS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};

export const getInvalidPrimDxInitials = (companyId: string) => (dispatch: ThunkDispatch<any, any, any>, getState: any) => {

  dispatch({ type: types.GET_INVALID_PRIM_DX_INITIALS_REQUEST });

  return api.claim.GetInvalidPrimDxInitials(companyId)
    .then((res: any) => {

      dispatch({
        type: types.GET_INVALID_PRIM_DX_INITIALS_SUCCESS,
        payload: res,
      });

      return res;
    })
    .catch((err: Error) => {
      const msg = _get(err, 'response.data.msg', 'Get failed!');
      const errors = _get(err, 'response.data.errors', {});
      const payload = { ...err, msg, errors };

      dispatch({
        type: types.GET_INVALID_PRIM_DX_INITIALS_FAILURE,
        payload,
      });

      return Promise.reject(payload);
    });
};